import { requestGet, requestPost } from '@/common/request';

export const queryRuleGuideList = async (data) => requestGet('/rule/guide', data);
export const queryRuleMainStrategy = async (data) => requestGet('/rule/mainStrategy', data);
export const queryRulePoolList = async (data) => requestGet('/rule/goodsPools', data);
export const getRuleByType = async (data) => requestGet('/goodsPool/getByType', data);
// 活动盘货 - 消息促达
export const messageSend = async ({ planCode }) => {
  return await requestPost('/rule/messageSend?planCode=' + planCode);
};
